import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import {
  ProgressBarBasicProps,
  ProgressBarStep,
  ProgressBarStepType,
} from './ProgressBarStep';

export type ProgressBarProps = ProgressBarBasicProps &
  PropsWithChildren<{
    stepData: ProgressBarStepType[];
  }>;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[5].px};
  justify-content: center;
`;

export const ProgressBar: React.FC<ProgressBarProps> = ({
  stepData,
  currentStep,
  setStep,
}: ProgressBarProps) => (
  <Wrapper>
    {stepData?.map((data) => {
      return (
        <ProgressBarStep
          {...data}
          currentStep={currentStep}
          setStep={setStep}
        />
      );
    })}
  </Wrapper>
);
